import React, { Component } from 'react';
import './PageStyles.css'
import prod from '../../Products';
import ProductList from '../productList/ProductList';




class FilterableProductPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            prod: prod,
            name: '',
            max: null,
            min: null
        }
    }

    enterKeyHandle = (e) => {
        if (e.key === 'Enter') {
            this.filterValues();
        }
    }

    filterOnChange = (e) => {

        this.setState({
            [e.target.id]: e.target.value
        })
    }

    filterValues = () => {
        let arr = prod;
        if (this.state.name.length > 0) {
            arr = this.filterNameValue(this.state.name, arr)
        }


        if (this.state.min) {
            arr = this.filterMinimumValue(this.state.min, arr)
        }

        if (this.state.max) {
            arr = this.filterMaximumValue(this.state.max, arr)
        }
        this.setState({
            prod: arr
        })

    }
    searchButton = () => {
        this.filterValues();
    }

    filterNameValue = (val, arr) => {
        return arr.filter(ob => {
            return ob.name.toLowerCase().match(val.trim().toLowerCase());
        })
    }

    filterMinimumValue = (val, arr) => {
        return arr.filter(ob => {
            return ob.priceNew >= parseInt(val)
        })
    }

    filterMaximumValue = (val, arr) => {
        return arr.filter(ob => {
            return ob.priceNew <= parseInt(val)
        })
    }

    render() {
        return (
            <div className="container">
                <div className="card-deck">
                    <div className="card">
                        <h5 className="text-center">Name</h5>
                        <input
                            onChange={this.filterOnChange}
                            onKeyDown={this.enterKeyHandle}
                            type="text" className="form-control" id="name" placeholder="Enter Amount" />
                    </div>
                    <div className="card">
                        <h5 className="text-center">Minimum Price</h5>
                        <input
                            onChange={this.filterOnChange}
                            onKeyDown={this.enterKeyHandle}
                            type="text" className="form-control" id="min" placeholder="Enter Amount" />
                    </div>
                    <div className="card">
                        <h5 className="text-center">Maximum Price</h5>
                        <input
                            onChange={this.filterOnChange}
                            onKeyDown={this.enterKeyHandle}
                            type="text" className="form-control" id="max" placeholder="Enter Amount" />
                    </div>
                    <div className="card bg-main btn-search"
                        onClick={this.searchButton}
                    >
                        <br />
                        <h4 className="text-center text-white">Click to Search</h4>
                        {/* <button className="btn bg-main text-white" onClick={this.searchButton}>Search</button>  */}
                    </div>
                </div>
                <br /><br />

                <ProductList prod={this.state.prod} />
            </div>

        );
    }
}

export default FilterableProductPage;
